var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"projectAddress-box"},[_c('HeaderNav',{attrs:{"header-title":"查看定位","left-icon-name":"2","right-icon-name":"3"}}),_c('div',{staticClass:"container"},[_c('div',{staticClass:"amap-demo",attrs:{"id":"amapDemo"}}),_c('div',{staticClass:"info-con"},[_vm._v(" "+_vm._s(_vm.address)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }